import Datetime from './Datetime.jsx'

const Date = (props) => {
  return (
    <Datetime timeFormat={false} locale="fr-FR" {...props}>
      {props?.children}
    </Datetime>
  )
}

export default Date
